import Section from "@/components/Section";
import { Box } from "@mui/material";
import { options } from "./mockData";
import HelpItem from "./components/HelpItem";

const HelpSection = () => {
  return (
    <Section pt={{ xs: 3, md: 8.5 }} pb={{ xs: 10, md: 17.5 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "normal", md: "space-between"}
        }}
      >
        {options.map((opt, index) => <HelpItem key={index} {...opt} />)}
      </Box>
    </Section>
  )
};

export default HelpSection;